// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RustApp from './rust/RustApp';
import ApexApp from './apex/ApexApp';
import PrivateLogin from './privatelogin/PrivateLogin';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RustApp />} />
        <Route path="/apex" element={<ApexApp />} />
        <Route path="/apex/*" element={<ApexApp />} />
        <Route path="/private-login" element={<PrivateLogin />} />
      </Routes>
    </Router>
  );
}

export default App;